import * as React from 'react';
import {useEffect} from 'react';
import Box from '@mui/material/Box';
import {useParams} from 'react-router-dom';
import QuestionCard from '../components/QuesAndAns/QuestionCard';
import CommonAppbar from '../components/common/CommonAppbar';
import ProfileOverview from '../components/ProfileOverview';
import Filters from '../components/Filters';

export default function OtherUsersProfile() {
  let {userId} = useParams();

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [userId])

  return (
    <Box sx={{flexGrow: 1, bgcolor: '#eeeeee'}}>

      <CommonAppbar isMainPage={true} pageHeader={userId}/>
      <ProfileOverview/>
      <Filters/>
      <QuestionCard/>
    </Box>
  );
}
